import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Category } from '../../../app/app.interfaces';


@Component({
  selector: 'category-drop-down',
  templateUrl: 'category-drop-down.html'
})

export class CategoryDropDown {

  @Input() form: FormGroup;
  @Input() formKey: string;
  @Input() categories: Category[];

  showCategoriesDropdown: boolean = false;

  constructor(private changeDetector: ChangeDetectorRef) {

  }

  toggleCategoriesDropdown(show: boolean = null){
    if(show!==null) this.showCategoriesDropdown = show;
    else this.showCategoriesDropdown=!this.showCategoriesDropdown;

    this.changeDetector.detectChanges();
  }
}



// WEBPACK FOOTER //
// ./src/partials/category/category-drop-down/category-drop-down.ts